import React from 'react'

function TenderTextINV() {
  return (
    <embed src="\pdfs\EAT1.1.9_IN-V_Adjustable_induction_outlet_kr (1).pdf" width="100%" height="2100px" />
  )
}

export default TenderTextINV